import React, { forwardRef, useState, useEffect } from "react";
import { Row, Col } from "antd";
import { InputItem } from "../../../components/forms/FormItems";
import SwitchItem from "../../../components/forms/SwitchItem";
import { FormattedMessage } from "react-intl";
import Surface from "../../../components/layouts/Surface";
import FormHeader from "../../../components/forms/FormHeader";
import Spacer from "../../../components/layouts/Spacer";
import ResponsiveItemsWrapper from "../../../components/layouts/ResponsiveItemsWrapper";
import PhoneNumberItem from "../../../components/forms/PhoneNumberItem";
import { useSelector } from "react-redux";

const Apotropus = forwardRef((props, ref) => {
  const { smallSpace } = props;
  const activePatient = useSelector(
    (state) => state.patientDetails.activePatient
  );
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(
      activePatient && activePatient.apotropus
        ? activePatient.apotropus.exists
        : false
    );
  }, [activePatient]);

  const onChange = (checked) => {
    setShow(checked);
  };
  return (
    <div style={{ display: "flex", flexDirection: "column" }} ref={ref}>
      <Surface smallSpace={smallSpace}>
        <FormHeader title={<FormattedMessage id="app.patients.apotropus" />} />
        <Row>
          <Col xs={24} sm={24} md={24} lg={21} xl={15} xxl={10}>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <SwitchItem
                  name="apotropus.exists"
                  category="patient"
                  onChange={onChange}
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}></div>
            </ResponsiveItemsWrapper>
            {show ? (
              <div>
                <ResponsiveItemsWrapper>
                  <div style={{ flex: 1 }}>
                    <InputItem name="apotropus.name" category="patient" />
                  </div>
                  <Spacer horizontal={true} />
                  <div style={{ flex: 1 }}>
                    <InputItem name="apotropus.address" category="patient" />
                  </div>
                </ResponsiveItemsWrapper>
                <ResponsiveItemsWrapper>
                  <div style={{ flex: 1 }}>
                    <PhoneNumberItem
                      name="apotropus.mobile_number"
                      category="patient"
                    />
                  </div>
                  <Spacer horizontal={true} />
                  <div style={{ flex: 1 }}>
                    <PhoneNumberItem
                      name="apotropus.phone_number"
                      category="patient"
                    />
                  </div>
                </ResponsiveItemsWrapper>
                <ResponsiveItemsWrapper>
                  <div style={{ flex: 1 }}>
                    <PhoneNumberItem
                      name="apotropus.fax_number"
                      category="patient"
                    />
                  </div>
                  <Spacer horizontal={true} />
                  <div style={{ flex: 1 }}>
                    <InputItem
                      name="apotropus.email"
                      category="patient"
                      email={true}
                    />
                  </div>
                </ResponsiveItemsWrapper>
              </div>
            ) : null}
          </Col>
        </Row>
      </Surface>
    </div>
  );
});

export default Apotropus;
